import React from 'react';
import { i18n } from '@lt/localization';
import SandIcon from '@lt/components/icons-react/rebrand/BeachSand';
import PebblleIcon from '@lt/components/icons-react/rebrand/BeachPebble';
import SandPebblleIcon from '@lt/components/icons-react/rebrand/BeachMixed';
import PlatformIcon from '@lt/components/icons-react/rebrand/BeachPlatform';

import HotelFeature from '../HotelFeature';

export const BEACH_SURFACE_TYPES = {
  SAND: {
    Icon: <SandIcon />,
    label: i18n.t('hotelcard.facts.surface.sand'),
  },
  PEBBLE: {
    Icon: <PebblleIcon />,
    label: i18n.t('hotelcard.facts.surface.pebble'),
  },
  'SAND+PEBBLE': {
    Icon: <SandPebblleIcon />,
    label: i18n.t('hotelcard.facts.surface.sand_pebble'),
  },
  PLATFORM: {
    Icon: <PlatformIcon />,
    label: i18n.t('hotelcard.facts.surface.platform'),
  },
};

type BeachSurfaceFeatureProps = {
  value: string | null;
  isMobile: boolean;
};

const BeachSurfaceFeature = ({ value, isMobile }: BeachSurfaceFeatureProps) => {
  if (!value) {
    return null;
  }

  const surfaceType = BEACH_SURFACE_TYPES[value && value.toUpperCase()];

  if (!surfaceType) {
    return null;
  }
  const { Icon, label } = surfaceType;
  return <HotelFeature Label={label} Icon={Icon} isMobile={isMobile} />;
};

export default BeachSurfaceFeature;
